export const internalNamespaces = ["epic", "SeaQA", "d5241c76f178492ea1540fce45616757"];
